/**
 *
 * Text Area
 *
 */
// import { FormattedMessage } from 'react-intl';
// import messages from './messages';

import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
// import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles'
import classNames from 'classnames'
import React from 'react'

import Icon from '../Icon'

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  stgInput: {
    padding: '0',
    '& >input, >textarea': {
      // border: '1px solid #ccc',
      // borderRadius: '3px',
      // padding: '10px',
      backgroundColor: `var(--gameday-inputField-inputBGColor, ${theme.inputField.inputBGColor})`,
    },
    '&:before': {
      // content: 'unset'
    },
    '&:after': {
      // content: 'unset'
    },
  },
  stgLabel: {
    margin: `0  0 ${theme.spacing(4)} 0`,
    position: 'unset',
  },
  mandatory: {
    color: theme.status.errorColor,
  },
  locked: {
    pointerEvents: 'none',
  },
  positionLeft: {
    position: 'absolute',
    right: 0,
    bottom: '4px',
  },
  positionRelative: {
    position: 'relative',
  },
})

/* eslint-disable react/prefer-stateless-function */
class TextareaWithLabel extends React.Component {
  render() {
    const { classes, ContainterStyle, label, value, isMandatory, onChange, isError, errorMessage, locked, ...rest } =
      this.props
    // const { filterData, selected } = this.state;
    return (
      <FormControl fullWidth className={classes.margin} error={isError}>
        {label ? (
          <InputLabel shrink={false} htmlFor={label} className={classes.stgLabel}>
            {label} {isMandatory && <span className={classes.mandatory}>*</span>}
          </InputLabel>
        ) : (
          ''
        )}

        <Input
          id={`input_${label}`}
          value={value}
          onChange={onChange}
          className={classNames(classes.stgInput, locked ? classes.locked : null)}
          rows={3}
          multiline
          readOnly={locked}
          {...rest}
        />
        {locked && (
          <div className={classes.positionRelative}>
            <Icon
              iconSize={15}
              iconName="lock"
              color="grey"
              className={classNames(classes.iconLeft, classes.positionLeft)}
            />
          </div>
        )}
        <FormHelperText id={`${label}-error-text`}>{isError && errorMessage}</FormHelperText>
      </FormControl>
    )
  }
}

TextareaWithLabel.defaultProps = {
  isMandatory: false,
  isError: false,
  errorMessage: 'Invalid value',
  locked: false,
}
export default withStyles(styles)(TextareaWithLabel)
